exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagefade-enter-active,.pagefade-leave-active{transition:opacity .2s}.pagefade-enter,.pagefade-leave-to{opacity:0}.pagefade{background:#fff;height:100%;width:100%;position:absolute;opacity:.5}.plyr__video-embed iframe{top:-50%;height:200%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-886c85fe","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Content/src/components/VideoViewer.vue
// module id = 987
// module chunks = 1